/**
 * The Office document settings key the tables add-in stores its settings under.
 */
export const TABLE_SETTINGS_NAME = "ZBITablesSettings";
